import { dataEmpty } from "components/CommonLib/CommonLib";
import CustomPagination from "components/CustomPagination/CustomPagination";
import CustomTable from "components/CustomTable/CustomTableTypeA";
import {
  CustomRow,
  CustomTableContents,
  CustomTableContentsEND,
} from "components/CustomTable/tableStyle";

const SearchResultTableSide = ({
  searchResult,
  detailSearchParam,
  navigate,
  curPage,
  setCurPage,
  totalPage,
  onClickSearch,
}) => {
  const searchResultList = new resultTable(navigate, detailSearchParam);

  const doSearch = (page) => {
    onClickSearch(false, page);
  };

  return (
    <div style={{ margin: "0px 1px" }}>
      <CustomTable
        columns_head={searchResultList.columns_head}
        table_title={searchResultList.table_title}
        rest_call={searchResultList.get_data_from_rest}
        row_render={searchResultList.create_table}
        rest_data={searchResult}
        width="100rem"
      />
      <CustomPagination
        curPage={curPage}
        // pageSelection={setCurPage}
        totalCnt={totalPage}
        doSearch={doSearch}
      />
    </div>
  );
};
export default SearchResultTableSide;

class resultTable {
  table_title = "";
  onNavigate = null;
  detailSearchParam = null;

  constructor(navigate, detailSearchParam) {
    this.onNavigate = navigate;
    this.detailSearchParam = detailSearchParam;
  }

  onClickEvent = (data) => {
    // this.onNavigate("/staff_info/", {
    //   state: {
    //     staff_id: data.staff_id,
    //     is_view: true,
    //   },
    // });
  };

  getSideStatus = (data) => {
    if (this.detailSearchParam.other_type) {
      switch (this.detailSearchParam.other_type) {
        case "운동복":
          return data.sub_result.active_mbshp.is_use_cloth === "사용" ? "사용" : "미사용";
        case "GX":
          return data.sub_result.active_mbshp.is_use_gx === "사용" ? "사용" : "미사용";
        case "락커":
          return data.sub_result.active_mbshp.is_use_locker === "사용" ? "사용" : "미사용";
        default:
          return "";
      }
    } else {
      return "";
    }
  };

  create_table = (data, idx) => {
    // console.log(data);
    return (
      <>
        <CustomRow
          style={{}}
          key={idx}
          // onClick={() => this.onClickEvent(data)}
          // sx={{
          //   "&.MuiTableRow-root:hover": {
          //     backgroundColor: "red",
          //   },
          // }}
          // className={this.styleClasses.MuiTableRow}
          hover
        >
          <CustomTableContents>{data.base_result.branch_info.branch_name}</CustomTableContents>
          <CustomTableContents>{data.base_result.member_type}</CustomTableContents>
          <CustomTableContents>{data.base_result.member_info.member_no}</CustomTableContents>
          <CustomTableContents>{data.base_result.member_info.member_name}</CustomTableContents>
          <CustomTableContents>{data.base_result.member_info.phone}</CustomTableContents>
          <CustomTableContents>{data.base_result.member_info.birth}</CustomTableContents>
          <CustomTableContents>{data.base_result.member_info.gender}</CustomTableContents>
          <CustomTableContents>{data.base_result.last_mbshp_to_date}</CustomTableContents>

          <CustomTableContents>{this.getSideStatus(data)}</CustomTableContents>
          <CustomTableContents>{data.sub_result.active_mbshp.from_date}</CustomTableContents>
          <CustomTableContents>{data.sub_result.active_mbshp.to_date}</CustomTableContents>
          <CustomTableContentsEND>
            {data.base_result.agree_marketing ? "동의" : "미동의"}
          </CustomTableContentsEND>
        </CustomRow>
      </>
    );
  };

  columns_head = [
    { title: "지점", width: "8%" },
    { title: "구분", width: "8%" },
    { title: "회원번호", width: "8%" },
    { title: "이름", width: "8%" },
    { title: "연락처", width: "8%" },
    { title: "생년월일", width: "8%" },
    { title: "성별", width: "8%" },
    { title: "최종 회원권 종료일", width: "8%" },

    // { title: "회원권 구매코드", width: "8%" },
    { title: "부가상품 상태", width: "8%" },
    { title: "시작일", width: "8%" },
    { title: "종료일", width: "8%" },
    { title: "마케팅 수신 동의", width: "8%" },
  ];

  get_data_from_rest = (stateData) => {
    if (dataEmpty(stateData)) {
      stateData = [];
    }
    return stateData;
  };
}
